export default __webpack_public_path__ + "static/media/heart-filled.a1e09885.svg";